const isStoreOpenNow = (store: {schedule?: {itsOpenNow?: boolean}}) => {
  const itsOpenNow = store?.schedule?.itsOpenNow

  return itsOpenNow
}

export default isStoreOpenNow
